import { Dispatch } from "redux";
import {
  GET_BANNERS,
  SET_BANNER_DATA,
  GET_USERS,
  SET_USER_DATA,
  GET_TRANSACTIONS,
  SET_TRANSACTION_DATA,
  SET_Polygon_DATA,
  GET_Location,
  SET_Location_DATA,
  SET_Centre_DATA,
  GET_Centre,
  UPDATE_BANNER,
  CREATE_BANNER,
  DELETE_BANNER,
  GET_POLYGON,
  CREATE_POLYGON,
  UPDATE_USER,
  CREATE_USER,
  SET_CITY_DATA,
  SET_AREAS_BY_CITY, 
  UPDATE_POLYGON,
  DELETE_POLYGON,
  DELETE_USER,
  GET_ROLES,
  SET_NETWORK_PARTNER_DATA,
  GET_NETWORK_PARTNERS,
  GET_COF_USERS,
} from "../../types/actions/Master.action";
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import { AppActions } from "types";
import { BannerData, PolygonData, RoleData, UserData } from "types/models/master/MasterApp";
import { AxiosResponse } from "axios";
import jwtAxios from "@crema/services/auth/jwt-auth";
import { CREATE_ROLE, DELETE_ROLE, SET_ROLE, UPDATE_ROLE } from "types/actions/roleMaster.action";


export const getBanners = (
  search: string,
  offset: number,
  limit: number 
) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());

    const params: any = {
      searchTerm: search,
      offset,
      limit, 
    };

    jwtAxios
      .get("banners/", { params })
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_BANNERS,
            payload: response.data.data, 
          });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};



export const getBannerDetail = (id: number | string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
    .get(`/banners/${id}`)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: SET_BANNER_DATA, payload: response.data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const createBanner = (formData: FormData) => {
  return (dispatch: Dispatch<AppActions>): Promise<AxiosResponse<any>> => {
    dispatch(fetchStart());

    return jwtAxios
      .post(`/banners/upload`, formData)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: CREATE_BANNER, payload: response.data });
        } else {
          dispatch(fetchError("Failed to create banner"));
        }
        return response;
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        return Promise.reject(error); 
      });
  };
};
export const updateBanner = (id: number, formData) => {
  return (dispatch: Dispatch<AppActions>): Promise<AxiosResponse<any>> => {
    dispatch(fetchStart());

    return jwtAxios
      .put(`/banners/upload/${id}`, formData)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: UPDATE_BANNER, payload: response.data });
        } else {
          dispatch(fetchError("Failed to update banner"));
        }
        return response; 
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        return Promise.reject(error); 
      });
  };
};
export const deleteBanner = (banner: BannerData) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    return jwtAxios
      .delete(`/banners/${banner.id}`)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: DELETE_BANNER, payload: banner.id });
          return response.data; 
        } else {
          throw new Error("Failed to delete banner");
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        throw error; 
      });
  };
};

export const createRole = (data: any) => {
  return (dispatch: Dispatch<AppActions>): Promise<AxiosResponse<any>> => {
    dispatch(fetchStart());

    return jwtAxios
      .post(`/roles`, data) 
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: CREATE_ROLE, payload: response.data });
        } else {
          dispatch(fetchError("Failed to create role"));
        }
        return response;
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        return Promise.reject(error);
      });
  };
};


export const deleteRole = (role: RoleData) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    return jwtAxios
      .delete(`/roles/${role.id}`)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: DELETE_ROLE, payload: role.id });
          return response.data; 
        } else {
          throw new Error("Failed to delete role");
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        throw error; 
      });
  };
};

export const getRoleDetail = (id: number | string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
    .get(`/roles/${id}`)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: SET_ROLE, payload: response.data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const updateRole = (id: number, formData) => {
  return (dispatch: Dispatch<AppActions>): Promise<AxiosResponse<any>> => {
    dispatch(fetchStart());

    return jwtAxios
      .put(`/roles/${id}`, formData)  
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: UPDATE_ROLE, payload: response.data });
        } else {
          dispatch(fetchError("Failed to update role"));
        }
        return response;
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        return Promise.reject(error);
      });
  };
};


export const getUsers = (
    search: string,
    offset: number,
  ) => {
    return (dispatch: Dispatch<AppActions>) => {
      dispatch(fetchStart());
      jwtAxios
        .get("users", {
          params: {
            searchTerm: search,
            offset,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            dispatch(fetchSuccess());
            dispatch({ type: GET_USERS, payload: response.data.data });
          } else {
            dispatch(fetchError("Something went wrong, Please try again!"));
          }
        })
        .catch((error) => {
          dispatch(fetchError(error.message));
        });
    };
  };

export const deleteUser = (user: UserData) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    return jwtAxios
      .delete(`/users/${user.id}`)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: DELETE_USER, payload: user.id });
          return response.data;
        } else {
          throw new Error("Failed to delete user");
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        throw error;
      });
  };
};
export const getUserDetail = (id: number | string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get(`users/${id}`)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: SET_USER_DATA,payload: response.data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};


export const updateUser = (id: number, users) => {
  return (dispatch: Dispatch<AppActions>): Promise<AxiosResponse<any>> => {
    dispatch(fetchStart());

    return jwtAxios
      .put(`/users/${id}`, users)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: UPDATE_USER, payload: response.data }); 
        } else {
          dispatch(fetchError("Failed to update user"));
        }
        return response;
      })
       .catch((error) => {
        if (error.response) {
          // API responded with a status
          if (
            error.response.status === 500 &&
            error.response.data?.message?.toLowerCase().includes("SR Code already exists")
          ) {
            dispatch(fetchError("SR Code already exists"));
          } else {
            dispatch(fetchError(error.response.data?.message || "Server error"));
          }
        } else if (error.request) {
          // No response received
          dispatch(fetchError("No response from server"));
        } else {
          // Something else went wrong
          dispatch(fetchError(error.message || "Request failed"));
        }

        return Promise.reject(error);
      });
  };
};

export const createUser = (user) => {
  return (dispatch: Dispatch<AppActions>): Promise<AxiosResponse<any>> => {
    dispatch(fetchStart());

    return jwtAxios
      .post(`/users`, user)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: CREATE_USER, payload: response.data });
        } else {
          dispatch(fetchError("Failed to create banner"));
        }
        return response; 
      })
      .catch((error) => {
        dispatch(fetchError("SR Code already exists"));
        return Promise.reject(error); 
      });
  };
};


export const getTransactions = (search: string, page: number) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/api/ecommerce/transactions", {
        params: { search, page },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_TRANSACTIONS, payload: data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getTransactionDetail = (id: number | string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/api/ecommerce/transaction/get", {
        params: { id: id },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: SET_TRANSACTION_DATA, payload: data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};


export const createPolygon = (polygonData: any) => {
  return (dispatch: Dispatch<AppActions>): Promise<AxiosResponse<any>> => {
    dispatch(fetchStart());
      return jwtAxios
      .post(`/latlong`, polygonData)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: CREATE_POLYGON, payload: response.data });
        } else {
          dispatch(fetchError("Failed to create banner"));
        }
        return response; 
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        return Promise.reject(error);
      });
  };
};


export const updatePolygon = (id: number, polygonData) => {
  return (dispatch: Dispatch<AppActions>): Promise<AxiosResponse<any>> => {
    dispatch(fetchStart());

    return jwtAxios
      .put(`/latlong/${id}`, polygonData)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: UPDATE_POLYGON, payload: response.data });
        } else {
          dispatch(fetchError("Failed to update user"));
        }
        return response;
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        return Promise.reject(error);
      });
  };
};



export const getPolygon = (search: string, page: number, pageSize: number = 10, fields: string = "") => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/latlong", {
        params: {
          searchTerm: search,
          page,
          pageSize,
          fields,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_POLYGON, payload: response.data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getPolygonsByCityId = (cityId: number) => {
  return (dispatch: Dispatch<AppActions>): Promise<any[]> => {
    dispatch(fetchStart());
    return jwtAxios
      .get(`/latlong/${cityId}`)
      .then((response) => {
        if (response.status === 200 && response.data.success === true) {
          dispatch(fetchSuccess());
          return response.data.data; 
        } else {
          dispatch(fetchError("Failed to fetch polygons by city ID"));
          return Promise.reject("Failed to fetch polygons");
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        return Promise.reject(error);
      });
  };
};


export const getPolygonDetail = (id: number | string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get(`/latlong/${id}`)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: SET_Polygon_DATA, payload: response.data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getPolygonDetailNormal = (area: string, city: string) => {
  return (dispatch: Dispatch<AppActions>): Promise<any> => {
    dispatch(fetchStart());
    return jwtAxios
      .get(`/latlong/locations`, {
        params: {
          area,
          city,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          return response.data.data;
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
          return Promise.reject("Something went wrong, Please try again!");
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        return Promise.reject(error.message);
      });
  };
};



export const fetchAreasByCityIdNormal = (cityId: number) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());

    return jwtAxios
      .get(`/area/getAreaByCity/${cityId}`)
      .then((response) => {
        if (response.status === 200 && response.data.success === true) {
          console.log(response.data.data)
          return response.data.data; 
        } else {
          dispatch(fetchError("Something went wrong, please try again!"));
          throw new Error("Fetch areas failed");
        }
      })
      .catch((error) => {
        console.error("Error fetching areas:", error);
        dispatch(fetchError(error.message));
        throw error;
      });
  };
};
export const deletePolygon = (polygon: PolygonData) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    return jwtAxios
      .delete(`/latlong/${polygon.latlong_id}`) 
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          
          
          dispatch({ type: DELETE_POLYGON, payload: polygon }); 

          return response.data; 
        } else {
          throw new Error("Failed to delete polygon");
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        throw error; 
      });
  };
};



export const getLocation = (search: string, page: number) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/api/ecommerce/location", { 
        params: { search, page },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_Location, payload: data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getLocationDetail = (id: number | string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/api/ecommerce/get", {
        params: { id: id },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: SET_Location_DATA, payload: data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
//  Centre Actions 
export const getCentre = (search: string, page: number) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/api/ecommerce/centre", {
        params: { search, page },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_Centre, payload: data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getCentreDetail = (sNo: number | string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/api/ecommerce/centre/get", {
        params: { sNo: sNo },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: SET_Centre_DATA, payload: data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};


export const fetchCities = (search: string = "", page: number = 1) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const response = await jwtAxios
      .get(`/cities?search=${search}&page=${page}`);
      dispatch(fetchSuccess());
      dispatch({
        type: SET_CITY_DATA,
        payload: response.data.data,
      });
      return response; 
    } catch (error: any) {
      dispatch(fetchError(error.message));
      throw error;
    }
  };
};


export const fetchAreasByCityId = (cityId: number) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());

    return jwtAxios
      .get(`/area/getAreaByCity/${cityId}`)
      .then((response) => {
        if (response.status === 200 && response.data.success === true) {
          dispatch(fetchSuccess());
          dispatch({ type: SET_AREAS_BY_CITY, payload: response.data });
          return response.data.data; 
        } else {
          dispatch(fetchError("Something went wrong, please try again!"));
          throw new Error("Fetch areas failed");
        }
      })
      .catch((error) => {
        console.error("Error fetching areas:", error);
        dispatch(fetchError(error.message));
        throw error;
      });
  };
};

export const getRoles = () => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get(`/roles`)         
      .then((response) => {
        if (response.status === 200 && response.data.status === "success") {
          dispatch(fetchSuccess());
          dispatch({ type: GET_ROLES, payload: response.data.data });
        } else {
          dispatch(fetchError("Something went wrong, please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getNetworkPartnerByAreaCode = (areaCode: string) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const response = await jwtAxios.get(`/np/getbyareacode/${areaCode}`);
      if (response.status === 200) {
        dispatch(fetchSuccess());
        dispatch({
          type: SET_NETWORK_PARTNER_DATA,
          payload: response.data.data,
        });
        return response;  
      } else {
        dispatch(fetchError("Failed to fetch network partners."));
        return null;
      }
    } catch (error: any) {
      dispatch(fetchError(error.message));
      return null;
    }
  };
};

export const getNetworkPartners = () => async (dispatch: Dispatch) => {
  dispatch(fetchStart());

  try {
    const res = await jwtAxios.get("/np");

    if (res.status === 200 && res.data.status === "success") {
      const networkPartners = (res.data.data || []).map((item: any) => ({
        id: item.id,
        partnerName: item.partner_name,
        partnerCode: item.partner_code,
      }));

      dispatch(fetchSuccess());
      dispatch({
        type: GET_NETWORK_PARTNERS,
        payload: networkPartners,
      });
    } else {
      dispatch(fetchError("Something went wrong, please try again!"));
    }
  } catch (err: any) {
    dispatch(fetchError("Error fetching network partners: " + err.message));
  }
  
};
export const getCofUsers = () => async (dispatch: Dispatch) => {
  dispatch(fetchStart());

  try {
    const res = await jwtAxios.get("/users/cof-user/activeData");

    if (res.status === 200 && res.data.status === "success") {
     dispatch(fetchSuccess());
      dispatch({
        type: GET_COF_USERS,
        payload: res.data.data,
      });
    } else {
      dispatch(fetchError("Something went wrong, please try again!"));
    }
  } catch (err: any) {
    dispatch(fetchError("Error fetching network partners: " + err.message));
  }
  
};

export const changePassword = (id: number, newPassword: string) => {
  return jwtAxios.post("/users/change-password", { id, newPassword });
};